const myQuizAnswersDefaultState = {
  myQuizAnswers: [],
  isMyQuizAnswersLoaded: false,
}

export default myQuizAnswersDefaultState
